import { hydrateWhenVisible } from '@theme/section-hydration';

function initHomeSectionsLazyHydration() {
  if (document.body.dataset.template !== 'index') return;

  const sections = document.querySelectorAll('.shopify-section[data-hydrate-on-visible="true"]');

  for (const section of sections) {
    const sectionId = section.id;
    if (!sectionId) continue;

    hydrateWhenVisible(sectionId);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHomeSectionsLazyHydration, { once: true });
} else {
  initHomeSectionsLazyHydration();
}